import Vue from 'vue';
const state = {
  token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMzk0OWZjMWZlYTdlYTEwZDRjMTQ2MGM5YTMzNjY4ZjJjZWE1YWMyYjFiYjY2ZDY0YjFjMDJkYjFiZGNjMTY3NzYyYzJhN2ExYzRmZDIxMmUiLCJpYXQiOjE2MDE2NDA2NTIsIm5iZiI6MTYwMTY0MDY1MiwiZXhwIjoxNjMzMTc2NjUyLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.jmXzxRf9HnJnLg1lIP4WwlX3STxOgNJGi-JREP8UKQ-0gGKYc9uVgvrYF5hCFQ1-wW0u3BWT4u9I9fK9luUgMDr7m2o95KUoj1EoopwiWBg5Y7TraXAHr9HVIUdavIumQuR83fycoGxft1GGWYSDU5rrvWrneL_uhTJ3iwHvJ1ULlgPncgu0qLKoOj4juSBtIT4OeEZoE6BfxORr4TiAOiQBLFWBHaki8KJzHNEAPaudaJAsG80Sh1ioReUaPT96qTcoMe1Z7gVBO15jfTgTGyJVvLjuYejVyuyK_S4syil6l_IZJWKjKPHIy1fSiFggO87SEbI8hvWgNAIFtYrBIfwO4Xsw1XDXGSqqZLJIIPdz8ta4Ongxe50X3pbKCOP_cd9fKG3XGlohpdidHRL0PgXybWsIuxFyJ6Dj80lsZDcY1eRIREOrVe1eaBoOzBW8lge3qz82nQRSaDi2iLCf3URQihknfsChMh6nd3v5dtdiU5gKSpqKT3r5A7A9bwR55XXBeF7vlOP7x3qVn993LexaPzm7iRtudNXFC7bjopULLnB8U4lUvpixl__6EQNMd_NRxBtlU-jc6GYD91dmm4ZVxSMiGGPB3Y7UAZczikQ4uPXzjBH-tueWvE_evaj1ubhcURVAOgqyamrN_UQkfRNH4Ne8DwCFpcSUDOTmMQA',
  auth: {
    user: null,
    permissions: null,
  },
  users: [],
  entreprises: [],
};

const getters = {
  auth: state => state.auth,
  users: state => state.users,
  entreprises: state => state.entreprises,
};

const actions = {

  getUser({ commit }) {
    if (!state.auth.user) {
      return new Promise((resolve, reject) => {
        window.axios.get('/api/user').then(response => {
          commit('setAuthUser', response.data);
          resolve(response);
        }).catch(error => {

        });
      });
    }
  },

  destroyUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      window.axios.delete('/api/user/'+user.id).then(response => {
        resolve(response);
      })
    });
  },

  getUsers({ commit }) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/users').then(response => {
        commit('setUsers', response.data);
        resolve(response);
      }).catch(error => {

      });
    });
  },

  getEntreprises({ commit }) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/entreprises').then(response => {
        commit('setEntreprises', response.data);
        resolve(response);
      });
    });
  },

  sendValidationCode({ commit }, email) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/sendValidationCode', {email}).then(response => {
        resolve(response);
      })
    });
  },

  updateEntreprise({ commit }, entreprise) {
    return new Promise((resolve, reject) => {
      window.axios.put('/api/entreprises/' + entreprise.id, entreprise).then(response => {
        resolve(response);
      })
    });
  },

  deleteEntreprise({ commit }, entreprise) {
    return new Promise((resolve, reject) => {
      window.axios.delete('/api/entreprises/' + entreprise.id).then(response => {
        resolve(response);
      })
    });
  },

  setUsers({ commit },user) {
    return new Promise((resolve, reject) => {
      window.axios.put('/api/users/' + user.id, user).then(response => {
        resolve(response);
      }).catch(error => {

      });
    });
  },

  createEntreprise({ commit }, entreprise) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/entreprises', entreprise).then(response => {
        resolve(response);
      });
    });
  },

  setUser({ commit },user) {
    return new Promise((resolve, reject) => {
      window.axios.put('/api/user/' + user.id, user).then(response => {
        resolve(response);
      })
    });
  },

  getPermissions({ commit }) {
    if (!state.auth.permissions) {
      return new Promise((resolve, reject) => {
        window.axios.get('/api/access').then(response => {
          commit('setAuthPermissions', response.data);
          resolve(response);
        }).catch(error => {

        });
      });
    }
  },

  register({ commit }, user) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/register', user).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  connectAccess({commit}, credential) {
    return new Promise((resolve, reject) => {
      window.axios.post('/api/se-connecter', {
            email : credential.user,
            password : credential.password,
        }).then(response => {
        resolve(response.data);
      }).catch(error => {
        console.log(error);

        reject(error);
      });
    });
  },

  disconnectAccess({commit}) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/se-deconnecter').then(response => {
        commit('resetAuth');
        resolve(response.data);
      }).catch(error => {
        console.log(error);

        reject(error);
      });
    });
  },

  entreprises({commit}, nom) {
    return new Promise((resolve, reject) => {
      window.axios.get('/api/entreprises',{
        params: {
          nom:nom
        }
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        console.log(error);

        reject(error);
      });
    });
  }

};

const mutations = {
  setUsers(state, users) {
    state.users = users.users;
  },
  setEntreprises(state, entreprises) {
    state.entreprises = entreprises;
  },
  setAuthUser(state, auth) {
    state.auth.user = auth;
  },
  setAuthPermissions(state, auth) {
    state.auth.permissions = auth.permissions
  },
  resetAuth(state) {
    state.auth = {
      user: null,
      permissions: null,
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};